import { Dialog,Toast} from 'vant';
import router from '../router'

export default {
    wxPay(dataList,name) {
        if (typeof WeixinJSBridge == "undefined"){
            if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady(dataList,name), false);
            }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady(dataList,name)); 
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady(dataList,name));
            }
        }else{
            onBridgeReady(dataList,name);
        }


        function onBridgeReady(dataList,name){
            console.log(dataList);
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    "appId":dataList.appId,     //公众号名称，由商户传入     
                    "timeStamp":dataList.timeStamp,         //时间戳，自1970年以来的秒数     
                    "nonceStr":dataList.nonceStr, //随机串     
                    "package":dataList.package,     
                    "signType":dataList.signType,         //微信签名方式：     
                    "paySign":dataList.paySign //微信签名 
                },
                function(res){
                    if(res.err_msg == "get_brand_wcpay_request:ok" ){ //支付成功后的操作
                        Toast({
                            message: '支付成功',
                            duration: 2000
                        });
                        // router.go(0);
                        window.location.reload();
                        if(name){
                            router.push({
                                'name':name,
                                query:{
                                    'id': dataList.orderId
                                }
                            })
                        }
                    }else if(res.err_msg=='get_brand_wcpay_request:cancel'){ //取消支付的操作
                        Toast({
                            message: '取消支付',
                            duration: 2000
                        });
                        if(name){
                            router.push({
                                'name':name,
                                query:{
                                    'id': dataList.orderId
                                }
                            })
                        }
                    }else{ //支付失败的操作
                        Toast({
                            message: '支付失败',
                            duration: 2000
                        });
                        if(name){
                            router.push({
                                'name':name,
                                query:{
                                    'id': dataList.orderId
                                }
                            })
                        }
                    }
                }
            ); 
        }
        
    }
}